require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./things-giftaidthing.json") })
        }
      }, "path---things-giftaidthing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---things-giftaidthing!./.cache/json/things-giftaidthing.json
// module id = 941
// module chunks = 231608221292675